import styles from './AuditionCard.module.css';

function AuditionCardFooter({ role, roles }) {
  const rolesToShow = roles?.length ? roles : role ? [role] : [];

  return (
    <div className={styles.cardFooter}>
      {rolesToShow.map((r, idx) => (
        <span key={idx} className={styles.roleTag}>{r}</span>
      ))}
    </div>
  );
}

export default AuditionCardFooter;
